<template>
  <div class="forgot-link">
    <router-link
      v-if="$router"
      class="ghost-btn"
      :to="to"
    >
      Passwort vergessen?
    </router-link>
    <a
      v-else
      class="ghost-btn"
      :href="to"
    >
      Passwort vergessen?
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  path: {
    type: String,
    default: '/forgot-password'
  }
});

const to = computed(() => props.path);
</script>

<style scoped>
.forgot-link {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.ghost-btn {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--border, #E0E3EA);
  border-radius: 6px;
  color: var(--text, #1F2937);
  text-decoration: none;
  background: var(--surface, #FFFFFF);
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
  font-size: 14px;
  line-height: 20px;
}

.ghost-btn:hover {
  text-decoration: underline;
  border-color: var(--primary, #4F46E5);
}

.ghost-btn:focus {
  outline: 2px solid var(--focus, rgba(79,70,229,.45));
  outline-offset: 2px;
}
</style>
